export const overlay = 'bg-white';
export const content = 'p-4';
export const stackedList = 'flex flex-col gap-1 pb-2';
export const fadButton = 'm-3 absolute bottom-6 right-0 z-10 px-3.5 py-2.5';
export const dialogContent = 'h-full overflow-y-hidden';
